import ImgOne from '../images/h1.jpg';
import ImgTwo from '../images/h2.jpg';
import ImgThree from '../images/h3.jpg';
import ImgFour from '../images/h4.jpg';


export const SliderData = [
    {
        title: 'Luxury Villa in Bali, Indonesia',
        price: '$4,200,000',
        path: '/homes',
        label: 'View Home',
        image: ImgOne,
        alt: 'House'
    },
    {
        title: 'House in San Jose, Costa Rica',
        price: '$2,200,000',
        path: '/homes',
        label: 'View Home',
        image: ImgTwo,
        alt: 'House'
    },
    {
        title: 'House in Calabasas, California',
        price: '$8,320,000',
        path: '/homes',
        label: 'View Home',
        image: ImgThree,
        alt: 'House'
    },
    {
        title: 'House in Houston, Texas',
        price: '$6,610,000',
        path: '/homes',
        label: 'View Home',
        image: ImgFour,
        alt: 'House'
    }
]